export default "__VITE_ASSET__98071f7c__"